import ErrorBox from '@components/common/ErrorBox';
import { AccordionStepsActionTypes } from '@state/features/common.types';
import Button from '@ui/button/Button';
import Loading from '@ui/loading/Loading';
import analytics from '@utils/analytics';
import api from '@utils/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
const AftercareStep5 = (props) => {
    const { t } = useTranslation();
    const [errors, setErrors] = React.useState([]);
    const [submitting, setSubmitting] = React.useState(false);
    const submit = () => {
        setErrors([]);
        setSubmitting(true);
        return api
            .aftercareSubmit()
            .then((data) => {
            setSubmitting(false);
            if (data.status === 'OK') {
                props.onSubmit(data);
                const contactDetailsAlternate = document.querySelector('.container.contact-details__alternate');
                if (contactDetailsAlternate) {
                    contactDetailsAlternate.style.display = 'none';
                }
                const heroBanner = document.querySelector('.myaccount-hero.client-services');
                if (heroBanner) {
                    heroBanner.style.display = 'none';
                }
                window.scrollTo(0, 0);
            }
            if (data.error && data.error.length > 0) {
                setErrors(data.error);
            }
            analytics.aftercareFive();
        })
            .catch((e) => setErrors([e]));
    };
    const dispatch = useDispatch();
    const handleGoBack = () => {
        dispatch({
            type: AccordionStepsActionTypes.NAVIGATE_STEP,
            payload: 'images',
        });
        analytics.aftercareBackEdit('review your request', 'back');
    };
    return (React.createElement("div", { className: "aftercare__form" },
        React.createElement("div", { className: "row" },
            React.createElement("p", { className: "col-10" }, t('aftercare.pleaseverify'))),
        React.createElement("div", { className: "row submit-button " },
            React.createElement("div", { className: "col-sm-6 d-none d-sm-flex " },
                React.createElement(Button, { type: "button", cls: ['button--tertiary', 'button--arrow-left'], onClick: handleGoBack }, t('button.back'))),
            React.createElement("div", { className: "col-sm-6" },
                React.createElement(Button, { type: "button", disabled: submitting, onClick: () => submit(), cls: ['button--primary'] }, t('aftercare.sendyourrequest')),
                submitting && React.createElement(Loading, null))),
        React.createElement(ErrorBox, { errors: errors })));
};
export default AftercareStep5;
